interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  return (
    <div className={align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl"}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 text-[11px] font-label tracking-[0.2em] uppercase mb-3 ${
            light ? "text-accent-400" : "text-primary-600"
          }`}
        >
          <span className={`w-6 h-px ${light ? "bg-accent-400" : "bg-primary-500"}`} />
          {eyebrow}
        </span>
      )}
      <h2
        className={`font-heading text-2xl md:text-4xl font-black leading-tight ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            light ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}